module.exports = __webpack_public_path__ + "static/Mirianne-Almeida-d7ba58a8ecd17b41404772f1feb5c972.jpg";